export const CHAT_SOURCE_ASC = 'asc';
export const CHAT_SOURCE_TF911 = 'tf911';
export const CHAT_SOURCE_RCS = 'rcs';

export const MAF_ERROR_REQUEST_FAILED = 'request_failed';
